export const products = [
  {
    id: 'gatetutor',
    title: 'GATEtutor',
    subtitle: 'Digital Learning & Employability Platform',
    description:
      "India's first AI-powered learning and employability system that brings together study, assessment, skill development, and career readiness on one platform.",
    features: [
      'Intelligent Study Centre',
      'Automated Test Creation',
      'Coding Assessments',
      'Resume Building',
      'Corporate Recruitment Integration',
    ],
    link: 'https://gatetutor.in',
    buttonText: 'Explore GATEtutor',
    visual: {
      name: 'GATEtutor',
      tagline: 'AI-Powered Learning',
      stats: [
        { number: '200+', label: 'Institutions' },
        { number: '11+ L', label: 'Students' },
      ],
    },
    image:
      'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=600&h=600&fit=crop',
  },
  {
    id: 'pragyaai',
    title: 'PragyaAI',
    subtitle: 'AI Intelligence Layer',
    description:
      "Microsage's proprietary AI engine that powers intelligent recommendations, analytics, personalization, and decision-making across learning and hiring — including campus recruitment workflows.",
    features: [
      'AI-based Assessment',
      'Role-Mapped Test Reports',
      'Resume Screening',
      'Employability Scores',
      'All-in-One ATS Dashboard',
    ],
    link: 'https://gatetutor.in',
    buttonText: 'Explore PragyaAI',
    highlight: true,
    visual: {
      name: 'PragyaAI',
      tagline: 'AI Intelligence Layer',
      stats: [
        { number: 'AI', label: 'Personalization' },
        { number: 'Data', label: 'Decision Support' },
      ],
    },
    image:
      'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=600&h=600&fit=crop',
  },
  {
    id: 'apex',
    title: 'APEX',
    subtitle: 'AI Productivity & Excellence Platform',
    description: [
      "APEX (AI Productivity & Excellence Platform) is Microsage's flagship AI-powered benchmarking framework designed to evaluate real-world AI productivity, professional competencies, and employability readiness. Unlike traditional assessments that measure theoretical knowledge, APEX evaluates how effectively individuals apply Artificial Intelligence to solve domain-specific challenges, make informed decisions, and deliver meaningful outcomes.",
      'Powered by PragyaAI and seamlessly integrated with GATEtutor, APEX transforms learning into measurable intelligence by providing a standardized benchmark for students, educational institutions, recruiters, and enterprises. It bridges the gap between academic learning and industry expectations by enabling data-driven evaluation of AI skills, productivity, and workforce readiness.',
    ],
    features: [
      'AI Productivity & Excellence Benchmark',
      'Domain-Specific Competency Assessment',
      'Real-World Scenario-Based Evaluation',
      'Employability Intelligence & Readiness Score',
      'Institution & Recruiter Analytics',
      'AI-Powered Performance Insights',
    ],
    link: '/contact',
    buttonText: 'Explore APEX',
    external: false,
    visual: {
      name: 'APEX',
      tagline: 'AI Productivity &\nExcellence Platform',
      stats: [
        { number: 'One Common', label: 'Benchmark' },
        { number: 'Outcome-Based', label: 'Intelligence' },
      ],
      stakeholders: ['Students', 'Institutions', 'Recruiters', 'Enterprises'],
    },
    image:
      'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=600&h=600&fit=crop',
  },
];
